import { IconButton, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import authStore from 'store/auth/auth'
import Icon from 'ui/atoms/Icon/Icon'
import WrikeFormHandler from 'ui/components/WrikeForm/wrikeFormHandler'
import { useSnapshot } from 'valtio'
import auroraLogo from '/img/abs_logo_white_text.svg'
import ExplorerMenu from './components/ExplorerMenu/ExplorerMenu'
import ProfileMenu from './components/ProfileMenu/ProfileMenu'
import SystemMenu from './components/SystemMenu/SystemMenu'
import styles from './Topbar.module.less'

type TopbarProps = {
  desktopDrawerOpen: boolean
  setDesktopDrawerOpen: (state: boolean) => void
  mobileDrawerOpen: boolean
  setMobileDrawerOpen: (state: boolean) => void
  notificationCenterOpen: boolean
  setNotificationCenterOpen: (state: boolean) => void
}

export default function Topbar({
  desktopDrawerOpen,
  setDesktopDrawerOpen,
  mobileDrawerOpen,
  setMobileDrawerOpen,
  notificationCenterOpen,
  setNotificationCenterOpen,
}: TopbarProps): ReactElement {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const { t } = useTranslation()
  const authSnap = useSnapshot(authStore)

  const menuOpen = isDesktop ? desktopDrawerOpen : mobileDrawerOpen

  function handleMenuToggle(): void {
    if (isDesktop) {
      setDesktopDrawerOpen(!desktopDrawerOpen)
    } else {
      setMobileDrawerOpen(!mobileDrawerOpen)
    }
  }

  return (
    <header className={styles.Topbar}>
      <div className={styles.Topbar_Item}>
        <Tooltip title={menuOpen ? t(`Minimize menu`) : t(`Expand menu`)} placement="right" arrow>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={handleMenuToggle}
            className={styles.Topbar_MenuButton}
          >
            <Icon color={'white'} size="large" icon="fal fa-bars" />
          </IconButton>
        </Tooltip>
      </div>

      <div className={styles.Topbar_Image}>
        <img src={auroraLogo} alt="Aurora by Sigholm" className={styles.Topbar_Image_Aurora} />

        {authSnap.isBeta && <div className={styles.Topbar_Image_Beta}>Beta</div>}
      </div>

      <div className={styles.Topbar_Item}>
        <WrikeFormHandler
          iFrameSource={
            'https://app-eu.wrike.com/form/eyJhY2NvdW50SWQiOjEwODY5OTgsInRhc2tGb3JtSWQiOjYzODg3MH0JNDg3Njc4NTExMTI0NQlmOWU0ZTZiYzJmNWMzY2YxMDQyNjExMGM1YzkzYzhjYjc0ZTJiNDQxNTg1OTg1NTFlOGE1YWZjZWMzYjk4YTA4'
          }
          title={t(`Contact us`)}
          hideTitle={!isDesktop}
        />
      </div>
      <div className={styles.Topbar_Item}>
        <ExplorerMenu hideLabel={!isDesktop} />
      </div>
      <div className={styles.Topbar_SystemMenuWrapper}>
        <SystemMenu />
      </div>
      <div className={styles.Topbar_Item}>
        <ProfileMenu />
      </div>
      <div className={styles.Topbar_Item}>
        <IconButton onClick={() => setNotificationCenterOpen(!notificationCenterOpen)}>
          <Icon
            color={'white'}
            size="large"
            icon={notificationCenterOpen ? 'fas fa-rectangle-list' : 'fal fa-rectangle-list'}
          />
        </IconButton>
      </div>
    </header>
  )
}
